export const implRequired = (funcName) => console.error(`Implementation Required! ${ funcName } has not been implemented!`)

export const inputValue = (setter) => (e) => setter(e.target.value)

export const inputIsNotEmpty = (e) => e.target.value.length !== 0

export const onEnter = (handler, additionalCheck = () => true) => (e) => {
    if (e.keyCode === 13 && additionalCheck(e)) handler()
}

export const clearOnActive = (defaultValue, active = true, ) => (e) => { if (active && e.target.value === defaultValue) e.target.value = ""}

export const revertOnEmpty = (defaultValue) => (e) => {
    if (!e.target.value) {
        e.target.value = defaultValue
    }
}

export const sentenceCase = (txt) => txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase()

export const titleCase = (str) => str.replace(/\w\S*/g, sentenceCase)

export const classList = (...classes) => classes.join(" ")

export const chunk = (arr, size) => arr.reduce((resultArray, item, index) => {
    const chunkIndex = Math.floor(index / size)

    if(!resultArray[chunkIndex]) {
        resultArray[chunkIndex] = [] // start a new chunk
    }

    resultArray[chunkIndex].push(item)

    return resultArray
}, [])
